import { gql } from "@apollo/client";

export const GET_ALL_FRECUENCIA_PROFESIONALES = gql`
query GetAllFrecuenciaProfesional {
    allFrecuenciaProfesional{
            idFrecuenciaProfesional,
            descripccion,
            descripcionpp,
            frecuencia,
            activo,
            fechaalta,
            idsuario,
            guardia
      }
}`;